module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAWCAMAAACFUC6CAAAAP1BMVEUAAAD0+P7j7PvT4fnD1vizzPakwvSRtfGCq/Byn+1jlOxSiupBf+cxc+UiaOL///9hlOvR3PcSEhIRERERERFVIHI0AAAAFHRSTlMAiYmJiYmJiYmJiYmJiYlcDQzjSQ5nysoAAABdSURBVCjPldA3DoAwAARBk3Mw8P+3gixtaS3eepq78PwqhBIYtHK40ylwI4MrGVwoC687wZly8JMJTpSHT4IjGRzIYE9RYEdRxrQU5Z6Gohxek8GKDB4k0AJ6RfAF3TMX5oA3UXgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/battery_management.png
// module id = all2
// module chunks = 8